import React from "react"
import {useQuery} from "@apollo/client"
import {Link} from "react-router-dom"
import {URL_BACKOFFICE_TRANSCODE_IMPORT_ADD_LIST} from "static/constant/url"

import IMPORT_LIST_QUERY from "graphql/Transcode/Import/query/importList"

import "./style.scss"
import {ImportDetails} from "../Details/ImportDetails"
import {BackofficePage} from "components/backoffice/Layout/BackofficePage"

export const ImportList = (props: any) => {

  const {data, loading, error} = useQuery(IMPORT_LIST_QUERY, {
    fetchPolicy: "cache-and-network",
  })
  const importList = data?.importList || []
  // const importStartMutationHook = useMutation(MUTATION_JOB_STOP)

  const hasElements = importList.length > 0
  const activeCount = importList.filter((item: any) => item?.isRunning || !["INITIAL", "DONE"].includes(item?.status)).length
  const doneCount = importList.filter((item: any) => item?.status === "DONE").length
  const errorCount = importList.filter((item: any) => item?.hasError).length

  return <BackofficePage
    className="import-list-container"
    eyebrow="Centre de traitement"
    title="Imports & transcodage"
    description="Suivez chaque fichier, de sa prise en charge jusqu'à sa mise en ligne."
    icon="fa-wave-square"
    actions={<Link className="bo-primary-action" to={URL_BACKOFFICE_TRANSCODE_IMPORT_ADD_LIST}>
        <span className="fas fa-plus" aria-hidden="true"></span>
        Nouvel import
      </Link>}
  >

    <section className="import-overview" aria-label="Résumé des imports">
      <div className="overview-card overview-card-total">
        <span className="overview-icon fas fa-layer-group" aria-hidden="true"></span>
        <div><strong>{importList.length}</strong><span>Au total</span></div>
      </div>
      <div className="overview-card overview-card-active">
        <span className="overview-icon fas fa-wave-square" aria-hidden="true"></span>
        <div><strong>{activeCount}</strong><span>En cours</span></div>
      </div>
      <div className="overview-card overview-card-done">
        <span className="overview-icon fas fa-check" aria-hidden="true"></span>
        <div><strong>{doneCount}</strong><span>Terminés</span></div>
      </div>
      <div className="overview-card overview-card-error">
        <span className="overview-icon fas fa-exclamation" aria-hidden="true"></span>
        <div><strong>{errorCount}</strong><span>À vérifier</span></div>
      </div>
    </section>

    <div className="import-section-heading">
      <div>
        <h2>File d'attente</h2>
        <p>{hasElements ? `${importList.length} import${importList.length > 1 ? "s" : ""} dans la file` : "Aucun fichier dans la file"}</p>
      </div>
      {loading && hasElements && <span className="refresh-indicator"><span className="icon-spinner"></span> Actualisation</span>}
    </div>

    {hasElements && <section className="import-stack">
      {importList?.map((importItem: any) => {
        return <ImportDetails importId={importItem?.id} key={importItem?.id} />
      })}
    </section>}

    {loading && !hasElements && <div className="import-empty-state import-loading-state" aria-live="polite">
      <span className="icon-spinner" aria-hidden="true"></span>
      <h2>Chargement des imports</h2>
      <p>Récupération de l'état de la file de traitement…</p>
    </div>}

    {error && !hasElements && <div className="import-empty-state import-error-state" role="alert">
      <span className="fas fa-plug" aria-hidden="true"></span>
      <h2>La file n'est pas disponible</h2>
      <p>Impossible de récupérer les imports pour le moment.</p>
    </div>}

    {!loading && !error && !hasElements && <div className="import-empty-state">
      <span className="fas fa-film" aria-hidden="true"></span>
      <h2>La file est vide</h2>
      <p>Ajoutez une vidéo pour lancer votre prochain traitement.</p>
      <Link className="bo-primary-action" to={URL_BACKOFFICE_TRANSCODE_IMPORT_ADD_LIST}>Ajouter un fichier</Link>
    </div>}
  </BackofficePage>

}
